
















































import { Component, Vue } from 'vue-property-decorator';
import { IParentProfile, IStudentListAccountItem } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';

import AccountForm from '@/components/forms/AccountForm.vue';
import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue'; 
import Accordion from '@/components/Accordion.vue';
import AccordionItem from '@/components/AccordionItem.vue';

@Component({
  name: 'account-page',
  components: { AccountForm, List, ListItem, Accordion, AccordionItem },
  beforeRouteEnter: async (to, from, next) => {
    const account = await AjaxHelper.get<IParentProfile<IStudentListAccountItem>>('parentprofile');
    for (let i = 0; i < account.students.length; ++i) {
      const student = account.students[i];
      student.birthDate = student.birthDate ? new Date(student.birthDate) : null;
    }

    next(vm => {
      (vm as any).account = account;
    });
  }
})
export default class AccountComponent extends Vue {
  public account: IParentProfile<IStudentListAccountItem> | null = null;
  public tab: 'settings' | 'grades' = 'settings';
}
